<template>
  <div class="box">
    <span class="version">version:{{ network.version }} device:{{ network.deviceId }}</span>
    <div class="hearder">
      <!-- <div class="row">
        <div class="name">{{ data.organizationName }}</div>
        <img v-if="data.percentOfPass > 80 || data.percentOfPass === 80" src="@/assets/visualization/good.svg" />
        <img v-if="data.percentOfPass < 80" src="@/assets/visualization/bad.svg" />
        <div>
          <div>合格率</div>
          <div class="efficiency">{{ data.percentOfPass }}%</div>
        </div>
      </div>
      <div class="row">
        质检作业
      </div>
      <div class="row">
        {{ Number(data.amountOfPass).toLocaleString() }}/{{ Number(data.amountOfQuality).toLocaleString() }}
      </div> -->
      <!-- <img src="@/assets/visualization/good.svg" /> -->
      <div class="row">
        <div class="name">{{ data.organizationName }}</div>
        <img style="width:33vw;margin:0 0 0 3vw" v-if="data.percentOfPass > 80 || data.percentOfPass === 80"
          src="@/assets/visualization/hare.svg" />
        <img style="width:26vw;margin:1vh 0 0 3vw"
          v-if="(data.percentOfPass > 60 && data.percentOfPass < 80) || data.percentOfPass === 60"
          src="@/assets/visualization/rabbit.svg" />
        <img style="width:41vw;margin:3.2vh 0 0 3vw" v-if="data.percentOfPass > 40 && data.percentOfPass < 60"
          src="@/assets/visualization/fastTortoise.svg" />
        <img style="width:25.4vw;margin:1.2vh 0 0 4vw" v-if="data.percentOfPass < 40 || data.percentOfPass === 40"
          src="@/assets/visualization/slowTortoise.svg" />
        <div class="date">
          <div>
            <span style="font-size: 30px;">{{ dateweek.day }} {{ dateweek.week }}</span>
            <span class="mock-block">
              <img class="icon" src="@/assets/visualization/calendar.svg" />
            </span>
          </div>
          <div>
            <span style="font-size: 30px;">{{ dateweek.time }}</span>
            <span class="mock-block">
              <img class="icon" src="@/assets/visualization/time.svg" />
            </span>
          </div>
          <div>
            <span style="font-size: 30px;color: red;" v-if="network.msg">{{network.msg}}</span>
          </div>
        </div>
      </div>
      <div class="overview">
        <div class="outputs">
          <div class="title">
            质检作业
          </div>
          <div :class="getFontSize()">
            {{ Number(data.amountOfPass).toLocaleString() }}/{{ Number(data.amountOfQuality).toLocaleString() }}
          </div>
        </div>
        <div :class="getEfficiency()">
          <div class="title">
            合格率
          </div>
          <div class="number">
            {{ data.percentOfPass }}%
          </div>
        </div>
      </div>
    </div>
    <div class="minBox">
      <div class="percentage">
        <div class="item">
          <div class="top-row">
            <div>直通</div>
            <div> {{ Number(data.directPass && data.directPass.amount).toLocaleString() }}/{{ Number(data.directPass &&
          data.directPass.sum).toLocaleString() }}
            </div>
          </div>
          <div class="bottom-row">
            <div>直通率</div>
            <div><span>{{ data.directPass && data.directPass.percent }}</span><span>%</span></div>
          </div>
        </div>
        <div class="item">
          <div class="top-row">
            <div>维修</div>
            <div> {{ Number(data.repair && data.repair.amount).toLocaleString() }}/{{ Number(data.repair &&
          data.repair.sum).toLocaleString() }}</div>
          </div>
          <div class="bottom-row">
            <div>修复率</div>
            <div><span>{{ data.repair && data.repair.percent }}</span><span>%</span></div>
          </div>
        </div>
      </div>
      <div style="overflow:hidden;position: relative;" ref='scrollContainer' :style="{
      '--playstate':data.departmentKanBanDtoListAll&&data.departmentKanBanDtoListAll.length>2?'runing':'paused',
      '--scrollduration':(data.departmentKanBanDtoListAll?data.departmentKanBanDtoListAll.length*5:20)+'s'
      }">
        <div class="scroll-box" ref='container'>
          <div v-for="(item, index) in data.departmentKanBanDtoListAll" :key="index">
            <div class="work-section">
              <div class="top-row">
                <div class="g-container">
                  <div class="g-progress"
                    :style="{ 'width': `${(Number(item.percentOfPass))}%`, 'background-color': getBgColor(item.percentOfPass) }">
                    <div class="text" v-if="item.percentOfPass">合格率{{ Number(item.percentOfPass) }}<span
                        v-if="item.percentOfPass != null">%</span></div>
                  </div>
                </div>
              </div>
              <div class="centre-row">
                <div class="item">
                  <div>{{ Number(item.amountOfPass).toLocaleString() }}</div>
                  <div>合格</div>
                </div>
                <div class="item">
                  <div>{{ Number(item.amountOfDirectPass).toLocaleString() }}</div>
                  <div>直通</div>
                </div>
                <div class="item">
                  <div>{{ Number(item.amountOfRepair).toLocaleString() }}</div>
                  <div>维修</div>
                </div>
                <div class="item">
                  <div>{{ Number(item.amountOfScrap).toLocaleString() }}</div>
                  <div>报废</div>
                </div>
              </div>
              <div class="bottom-row">
                <div>{{ item.organizationName }}</div>
                <div>{{ Number(item.amountOfPass).toLocaleString() }}/{{ Number(item.amountOfQuality).toLocaleString()
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="scroll-box1" ref='container'>
          <div v-for="(item, index) in data.departmentKanBanDtoListAll" :key="index">
            <div class="work-section">
              <div class="top-row">
                <div class="g-container">
                  <div class="g-progress"
                    :style="{ 'width': `${(Number(item.percentOfPass))}%`, 'background-color': getBgColor(item.percentOfPass) }">
                    <div class="text" v-if="item.percentOfPass">合格率{{ Number(item.percentOfPass) }}<span
                        v-if="item.percentOfPass != null">%</span></div>
                  </div>
                </div>
              </div>
              <div class="centre-row">
                <div class="item">
                  <div>{{ Number(item.amountOfPass).toLocaleString() }}</div>
                  <div>合格</div>
                </div>
                <div class="item">
                  <div>{{ Number(item.amountOfDirectPass).toLocaleString() }}</div>
                  <div>直通</div>
                </div>
                <div class="item">
                  <div>{{ Number(item.amountOfRepair).toLocaleString() }}</div>
                  <div>维修</div>
                </div>
                <div class="item">
                  <div>{{ Number(item.amountOfScrap).toLocaleString() }}</div>
                  <div>报废</div>
                </div>
              </div>
              <div class="bottom-row">
                <div>{{ item.organizationName }}</div>
                <div>{{ Number(item.amountOfPass).toLocaleString() }}/{{ Number(item.amountOfQuality).toLocaleString()
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dateweek: {
      type: Object
    },
    network: {
            type: Object
        },
    payload: {
      type: Array,
      default: () => [],
    },
    organizationName: String
  },
  data() {
    return {
      data: {
        organizationName: '',
        amountOfPass: '',
        amountOfQuality: '',
        percentOfPass: '',
        directPass: {},
        repair: {},
        departmentKanBanDtoList: [],
        departmentKanBanDtoListAll: [],
      },
      scrollTimer: null
    }
  },
  watch: {
    payload() {
      this.setpayload()
    }
  },
  created() {
    this.setpayload()
  },
  // 挂载时间
  methods: {
    setpayload() {
      this.data = {
        organizationName: this.organizationName,
        amountOfPass: this.payload[0].amountOfPass,
        amountOfQuality: this.payload[0].amountOfQuality,
        percentOfPass: this.payload[0].percentOfPass,
        directPass: this.payload[0].directPass,
        repair: this.payload[0].repair,
        departmentKanBanDtoListAll: this.payload[0].organizationList,
        departmentKanBanDtoList: [],
      }
      // if (this.data.departmentKanBanDtoListAll.length > 2) {
      //   this.startScroll()
        
      // }
      // if (this.data.departmentKanBanDtoListAll && this.data.departmentKanBanDtoListAll.length > 0) {
      //   this.data.departmentKanBanDtoList = this.data.departmentKanBanDtoListAll.slice(0, 2)
      // }
    },
    startScroll() {
      // 清除定时器
      clearTimeout(this.scrollTimer)
      // 定时器触发周期
      this.scrollTimer = setInterval(this.scroll, 30)
    },
    scroll() {
      //console.log('scroll')
      if (this.$refs.scrollContainer) {
        const box = this.$refs.scrollContainer
        const container = this.$refs.container
        if (container.clientHeight > box.clientHeight) {
          // console.log('22222---22222',box.scrollTop);
          // 组件进行滚动
          box.scrollTop += 1
          // 判断滚动条是否滚动到底部
          if (box.scrollTop >= container.clientHeight - box.clientHeight) {
            // console.log('33333---33333');
            // 获取组件第一个节点
            const firstNode = container.childNodes[0]
            container.scrollTop = 0
            // 删除节点
            container.removeChild(firstNode)
            // 将该节点拼接到组件最后
            container.append(firstNode)
          }
        }
      }
    },
    // 将数字转换w,kw单位
    formatNumber(number) {
      let num = number ? Math.round(number) : 0
      let result = ''
      if (num.toString().length > 5 && num.toString().length < 7) {
        result = (num / 1e4).toFixed(1) + 'w';
      } else if (num.toString().length >= 7) {
        result = (num / 1e7).toFixed(1) + 'kw';
      } else {
        result = num
      }
      return result
    },
    getEfficiency() {
      if (this.data.percentOfPass >= 60) {
        return 'high-rate'
      } else if (this.data.percentOfPass >= 40 && this.data.percentOfPass < 60) {
        return 'middle-rate'
      } else {
        return 'low-rate'
      }
    },
    getFontSize() {
      let len = this.data.amountOfPass.toString().length + this.data.amountOfQuality.toString().length
      if (len <= 8) {
        return 'number'
      } else if (len > 8 && len <= 12) {
        return 'number-60'
      } else {
        return 'number-40'
      }
    },
    getBgColor(val) {
      if (val <= 40) {
        return '#FA5151'
      } else if (val > 40 && val < 60) {
        return '#F5B130'
      } else {
        return '#00B578'
      }
    },

  },
  beforeCreate() {
    document.getElementsByTagName('body')[0].style.margin = '0'
  },
}
</script>
<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.box {
  height: 100%;
  width: 100%;

  .hearder {
    height: 587px;
    width: calc(100vw - 100px);
    background: #D0E9FF;
    padding: 40px 50px 13px;
    font-size: 54px;
    color: #333;

    .row:first-child {
      margin-bottom: 40px;
      display: flex;
      justify-content: space-between;

      .name {
        text-align: left;
        width: 220px;
        word-wrap: break-word;
      }

      img {
        // width: 344px;
        // height: 320px;
        // margin-top:-36px
      }

      div {
        .efficiency {
          font-size: 110px;
        }
      }

      .date {
        text-align: right;

        .icon {
          width: 30px;
          height: auto;
          vertical-align: middle;
          margin: 0 0 0 20px;
        }
      }
    }

    .row:last-child {
      font-size: 110px;
    }

    .overview {
      display: flex;
      justify-content: space-between;
      color: #fff;
      height: 250px;

      &>div {
        text-align: center;
        border-radius: 10px 10px 10px 10px;
        padding: 40px 0;
        width: calc(50% - 10px);
        height: 250px;
        box-sizing: border-box;

        .title {
          font-size: 50px;
          margin-bottom: 24px;
        }

        .number {
          font-size: 80px;
        }

        .number-60 {
          font-size: 60px;
        }

        .number-40 {
          font-size: 40px;
        }
      }

      .outputs {
        background-color: #333;
        margin-right: 20px;
      }

      .high-rate {
        background-color: #00B578;
      }

      .middle-rate {
        background-color: #F5B130;
      }

      .low-rate {
        background-color: #FA5151;
      }
    }
  }

  .minBox {
    padding: 20px 50px;

    .percentage {
      display: flex;
      justify-content: space-between;
      height: 300px;

      .item:nth-child(1) {
        width: 510px;
        margin: 0 20px 0 0;

        .top-row {
          height: 180px;
          border: 5px solid #333;
          color: #000;
          border-radius: 10px 10px 0 0;
          box-sizing: border-box;
          padding: 23px 0
        }

        .bottom-row {
          height: 110px;
          background: #333;
          border-radius: 0 0 10px 10px;
        }
      }

      .item:nth-child(2) {
        width: 510px;

        .top-row {
          height: 180px;
          border: 5px solid #333;
          color: #FA5151;
          border-radius: 10px 10px 0 0;
          box-sizing: border-box;
          padding: 23px 0;
          font-size: 60px
        }

        .bottom-row {
          height: 110px;
          background: #333;
          border-radius: 0 0 10px 10px;
        }
      }

      .item {
        font-size: 50px;

        .bottom-row {
          padding: 0px 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #FFFFFF;
        }
      }
    }
    --scrollduration:30s;
    --playstate:paused;
    .scroll-box {
      height: calc(100vh - 1000px);
      margin-top: 25px;
      animation: scroll var(--scrollduration) linear 2s infinite;
      animation-play-state: var(--playstate);
    }
    .scroll-box1 {
      height: calc(100vh - 1000px);
      animation:scroll1 var(--scrollduration) linear 2s infinite;
      animation-play-state: var(--playstate);
    }

    .work-section {
      height: 425px;
      margin-top: 25px;
      border: 5px solid #333;
      border-radius: 10px;
      box-sizing: border-box;

      .top-row {
        height: 70px;
        background: #EFEFEF;

        .g-container {
          width: 100%;
          height: 70px;
          position: relative;

          // border-radius: 25px;
          // background: #eee;
          .text {
            font-size: 36px;
            // position: absolute;
            // top: 0px;
            // right: 40px;
            color: #fff;
            line-height: 64px;
            padding: 0 20px 0 0;
          }
        }

        .g-progress {
          // width: 70%;
          height: inherit;
          border-radius: 0px 25px 25px 0px;
          background: #00B578;
          // font-size: 36px;
          color: #FFFFFF;
          text-align: right;
        }

      }

      .centre-row {
        height: 235px;
        border-bottom: 5px solid #333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 40px;
        box-sizing: border-box;

        .item {
          color: #000;

          div:first-child {
            font-size: 50px;
            font-weight: bold;
          }

          div:last-child {
            font-size: 40px;
            color: #000000;
          }
        }

        .item:last-child {
          color: #FA5151;
        }
      }

      .bottom-row {
        background: #333;
        height: 110px;
        font-size: 50px;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 40px;
      }
    }
  }
}
.version{
    font-size:20px;
    position: absolute;
    left: 0px;
    top: 10px;
    color:rgba(0, 0, 0, 0.3)
}

@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}

@keyframes scroll1 {
  0% {
    transform: translateY(100%);
  }
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/production/Quality.vue